import React from 'react';
import { Grid } from '@material-ui/core';
import {
  string,
  node,
  oneOfType,
} from 'prop-types';
import DefaultContainer from '../../DefaultContainer';
import styles from './style.module.scss';

const TitleAndBodySection = ({
  title,
  body,
  className,
  ...props
}) => (
  <DefaultContainer
    className={[
      styles.container,
      className,
    ].join(' ')}
    {...props}
  >
    <Grid item md={6}>
      <h3 className={styles.title}>{title}</h3>
      <p>{body}</p>
    </Grid>
  </DefaultContainer>
);

TitleAndBodySection.propTypes = {
  className: string,
  title: oneOfType([
    string,
    node,
  ]),
  body: oneOfType([
    string,
    node,
  ]),
};

TitleAndBodySection.defaultProps = {
  className: null,
  title: null,
  body: null,
};

export default TitleAndBodySection;
